import { render, staticRenderFns } from "./CreatedPage.vue?vue&type=template&id=b7c0446e&lang=true&"
import script from "./CreatedPage.vue?vue&type=script&lang=js&"
export * from "./CreatedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports